module.exports = __webpack_public_path__ + "img/product_standard_disabled_mobile.f3e6d980.png";